import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "88",
  height: "48",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#13161B",
      d: "M0 0h88v48H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#949EAA",
      "fill-rule": "evenodd",
      d: "M52.533 26.87q-.748.129-1.533.13a9 9 0 0 1-8.533-11.87A9 9 0 0 0 44 33a9 9 0 0 0 8.533-6.13",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }